/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementCreateLivecarpResponse } from './LiveManagementCreateLivecarpResponse';

export type LiveManagementCreateLivecarpResponseApiRespoonse = {
    data?: LiveManagementCreateLivecarpResponse;
    status?: LiveManagementCreateLivecarpResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementCreateLivecarpResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

